<dx-popup
  [showTitle]="true"
  title="Edition des bons d'allotissement "
  [(visible)]="displayDialog"
  [width]="400"
  [height]="'auto'"
  [maxHeight]="800"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (onHidden)="closeDialog()"
>
  <div class="settings">
  <div class="dialog-line">
    <div class="print-settings">
      <span>ORDRE D'IMPRESSION</span>
      <dx-radio-group [(value)]="grouping" valueExpr="value" displayExpr="label"
                      [items]="formatPrintingOptions"></dx-radio-group>
    </div>
  </div>

  <div class="dialog-line">
    <div class="print-settings">
      <span class="strong">OPTION D'IMPRESSION</span>
      <dx-check-box
        [(ngModel)]="totalAndTraca" text="Totaux / Traçabilité"
        [value]="false">
      </dx-check-box>
      <dx-check-box
        [(ngModel)]="dontDisplayMeal" text="Ne pas tenir compte des repas"
        [value]="false">
      </dx-check-box>
      <dx-check-box
        [(ngModel)]="displayVariante" text="Afficher la variante de conditionnement"
        [value]="false">
      </dx-check-box>
    </div>
  </div>

  <div class="dialog-line">
    <div class="print-settings">
      <div> DATE DE TRI</div>
      <dx-radio-group [(value)]="sorting" valueExpr="value" displayExpr="label"
                      [items]="sortPrintingOptions"></dx-radio-group>
    </div>
  </div>

  <div class="custom-button-container-right">
    <yo-button label="Imprimer" iconClass="fas fa-print"
      [theme]="ButtonThemeEnum.DEFAULT"
               (onClick)="downloadBonAllotissement()">
    </yo-button>
    <yo-button iconClass="fas fa-times"
      [theme]="ButtonThemeEnum.CANCEL" (click)="closeDialog()">
    </yo-button>
  </div>
  </div>

</dx-popup>
